if (typeof Element.prototype.closest !== 'function') {
  Element.prototype.closest = function closestFunction(selector: string) {
    const document = this.ownerDocument;

    for (
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let node: Node | null = this;
      node && node !== document;
      node = node.parentNode
    ) {
      if (
        node.nodeType === Node.ELEMENT_NODE &&
        (node as Element).matches(selector)
      ) {
        return node as Element;
      }
    }

    return null;
  };
}
